module.exports = __webpack_public_path__ + "img/home.f048fd06.jpg";